import { TooltipPlacement } from 'antd/lib/tooltip';
import { TOptions } from 'i18next';
import { useCallback } from 'react';
import { ApolloError } from '@apollo/client';
import { openToast } from '@tools/ui-utils/toast.util';
import useT from './useT';

const useNotifyActionHook = ({
  successMsg,
  errorMsg,
  onCompleteCb,
  options,
  placement = 'bottomLeft'
}: {
  successMsg?: string;
  errorMsg?: string;
  onCompleteCb?: VoidFunction;
  options?: TOptions;
  placement?: TooltipPlacement;
}) => {
  const { t } = useT();

  const onCompleted = useCallback(
    (overrideMessage?: string) => {
      if (successMsg) {
        const message = overrideMessage || t(successMsg, options);
        openToast({
          type: 'success',
          message,
          placement
        });
      }
      onCompleteCb?.();
    },
    [t, successMsg, options, placement, onCompleteCb]
  );

  const onError = useCallback(
    (error: ApolloError | Error) => {
      if (errorMsg) {
        const message = t(errorMsg, options);
        openToast({
          type: 'error',
          message,
          description: error.message,
          placement
        });
      }
    },
    [t, errorMsg, options, placement]
  );

  return { onCompleted, onError };
};

export default useNotifyActionHook;
